import { render, staticRenderFns } from "./NbPageFooter.vue?vue&type=template&id=4bd1777e&scoped=true&"
import script from "./NbPageFooter.vue?vue&type=script&lang=js&"
export * from "./NbPageFooter.vue?vue&type=script&lang=js&"
import style0 from "./NbPageFooter.vue?vue&type=style&index=0&id=4bd1777e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd1777e",
  null
  
)

export default component.exports